import { devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';
import { AgentMinerTab } from '../../containers/agent-miner/agent-miner.type';
import { createSafeJSONStorage } from '../../helpers/storage/persist-storage';
import { isLoggingEnabled, logger } from '../logger/logger';
import type { AgentMinerStore } from './agent-miner-store.type';

/**
 * Store for Agent Miner page state. Persists the active tab to localStorage
 * so returning to the page restores the last-visited tab.
 */
const useAgentMinerStore = create<AgentMinerStore>()(
  devtools(
    persist(
      logger((set) => ({
        activeTab: AgentMinerTab.Sessions,
        setActiveTab: (activeTab: AgentMinerTab) => set({ activeTab }),
      })),
      {
        name: 'agent-miner-storage',
        storage: createSafeJSONStorage(() => localStorage),
        partialize: (state) => ({ activeTab: state.activeTab }),
      },
    ),
    {
      name: 'Bloomfilter - Agent Miner Store',
      enabled: isLoggingEnabled,
    },
  ),
);

export { useAgentMinerStore };
